import { render } from "./TotalReported.vue?vue&type=template&id=2849cf8d&ts=true"
import script from "./TotalReported.vue?vue&type=script&lang=ts"
export * from "./TotalReported.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__